import { useState, useEffect, useRef, useCallback } from "react";

export const usePwa = () => {
  const [canInstall, setCanInstall] = useState(false);
  const [isInstalled, setInstalled] = useState(false);
  const [userChoice, setUserChoice] = useState("unknown");
  const deferredPrompt = useRef();

  const handleInstallEvent = useCallback(() => setInstalled(true), []);

  const handleBeforePromptEvent = useCallback((event) => {
    event.preventDefault();
    deferredPrompt.current = event;
    setCanInstall(true);
  }, []);

  useEffect(() => {
    window.addEventListener("beforeinstallprompt", handleBeforePromptEvent);
    return () =>
      window.removeEventListener(
        "beforeinstallprompt",
        handleBeforePromptEvent,
      );
  }, [handleBeforePromptEvent]);

  useEffect(() => {
    window.addEventListener("appinstalled", handleInstallEvent);
    return () => window.removeEventListener("appinstalled", handleInstallEvent);
  }, [handleInstallEvent]);

  const installPrompt = useCallback(async () => {
    if (!deferredPrompt.current) return;

    deferredPrompt.current.prompt();
    const choiceResult = await deferredPrompt.current.userChoice;
    deferredPrompt.current = null;
    setUserChoice(choiceResult.outcome);
  }, []);

  return {
    installPrompt,
    isInstalled,
    canInstall,
    userChoice,
  };
};
